"use client";

import { useState } from "react";
import Button from "src/components/common/Button/Button";
import type { SchemaExportData } from "src/lib/DocsSchemaExport";
import { lazyComponent, loadLazyModule } from "src/lib/LazyModules";
import { useExtracted } from "#i18n";

const SchemaExportDialog = lazyComponent("schemaExportDialog", "default");

export default function SchemaExportButton({
  data,
  name = "schema",
}: {
  data: SchemaExportData;
  name?: string;
}) {
  const [visible, setVisible] = useState(false);
  const t = useExtracted();
  const preload = () => void loadLazyModule("schemaExportDialog");
  return (
    <>
      <Button
        label={t("View schema")}
        type="button"
        size="sm"
        variant="outline"
        onMouseEnter={preload}
        onFocus={preload}
        onClick={() => setVisible(true)}
      >
        {t("View schema")}
      </Button>
      {visible && (
        <SchemaExportDialog
          data={data}
          name={name}
          visible={visible}
          onVisibleChange={setVisible}
        />
      )}
    </>
  );
}
